// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"93a67f56","575":"137a8e5b","744":"2c77b592","801":"156f5e82","981":"dede54eb"}[chunkId] + ".chunk.js";
};